import contacto from "../../assets/img/bg-dejanos-tu-consulta.png";

import "./afiliarme.scss";

import ReCAPTCHA from "react-google-recaptcha";
import { Formik } from "formik";
import Swal from "sweetalert2";
import React from "react";

import { PoliticaProteccionComponent } from "../../components/footer/politica-proteccion/index";
import { validateModel } from "./validationSchema";
import { useToggle } from "../../hooks/useToggle";
import { fetch } from "../../utils/fetch";
import { sendFormZoho } from "../../utils/send-form-zoho";

let emailsData;
process.env.REACT_APP_ENVIROMENT_DEBUG === "true"
  ? import("../../data/emails/emails.develop.json").then((module) => {
      emailsData = module.default;
    })
  : import("../../data/emails/emails.prod.json").then((module) => {
      emailsData = module.default;
    });

const AfiliarmePage = () => {
  const captcha = React.useRef(null);
  const politicaToggle = useToggle();
  const initialValues = {
    nombre: "",
    apellido: "",
    //edad: "",
    email: "",
    celular_prefix: "",
    celular: "",
    //mensaje: "",
    aceptoPrivacidad: false,
    validateAceptoPrivacidad: "",
  };

  React.useEffect(() => {
    const salesiqWidget = window.$zoho;
    salesiqWidget.salesiq.floatbutton.visible("show");

    return () => {
      salesiqWidget.salesiq.floatbutton.visible("hide");
    };
  }, []);

  const onSubmit = async (values, resetForm) => {
    if (captcha.current?.getValue()) {
      const correo = {
        to: emailsData.afiliarme,
        subject: "Solicitud de contacto",
        text: `<b>Nombre</b> ${values.nombre} <br/>
        <b>Apellido</b> ${values.apellido} <br/>
        <b>Email</b> ${values.email} <br/>
        <b>Celular</b> (${values.celular_prefix})${values.celular} <br/>
        `,
      };
      const { data } = await fetch(`email`, "post", correo);
      resetForm();
      captcha.current?.reset();
      Swal.fire("Info!", "Solicitud de contacto enviada con éxito", "info");

      // Send data to zoho CRM
      sendFormZoho(values);
    } else {
      Swal.fire("Info!", "Debe indicar que no es un robot", "info");
    }
  };

  const handleChangeValue = (e, setFieldValue, handleChange, limit) => {
    const { name, value } = e.target;
    if (value.length > limit) {
      const truncatedValue = value.slice(0, limit);

      setFieldValue(name, truncatedValue);
    } else {
      handleChange(e);
    }
  };

  return (
    <section className="section_contacto">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 p-5">
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validateModel}
              onSubmit={(values, { resetForm }) => {
                onSubmit(values, resetForm);
              }}
            >
              {({
                values,
                errors,
                handleChange,
                handleSubmit,
                setFieldValue,
              }) => (
                <form className="section_contacto_form" onsubmit={handleSubmit}>
                  <h2 className="subtitle-global">
                    <b>Afiliate a Nuestro Plan de Salud</b>
                  </h2>
                  <hr className="hr6" style={{ borderTop: "0px" }} />
                  <div className="mb-4 fila-contacto align-items-center red-asterisk">
                    <div>
                      <label>
                        Nombre <span>*</span>
                      </label>
                    </div>
                    <div>
                      <input
                        type="text="
                        name="nombre"
                        value={values.nombre}
                        onChange={(e) =>
                          handleChangeValue(e, setFieldValue, handleChange, 25)
                        }
                        className="form-control b-radius-20 "
                      />
                      <div className="text-danger">{errors?.nombre}</div>
                    </div>
                  </div>

                  <div className="mb-4 align-items-center fila-contacto red-asterisk">
                    <div>
                      <label style={{ width: "100px", minWidth: "100px" }}>
                        Apellido <span>*</span>
                      </label>
                    </div>
                    <div>
                      <input
                        type="text="
                        name="apellido"
                        value={values.apellido}
                        onChange={(e) =>
                          handleChangeValue(e, setFieldValue, handleChange, 25)
                        }
                        className="form-control b-radius-20 shadow-blue"
                      />
                      <div className="text-danger">{errors?.apellido}</div>
                    </div>
                  </div>

                  <div className="mb-4 align-items-center fila-contacto red-asterisk">
                    <div>
                      <label>
                        Email <span>*</span>
                      </label>
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        className="form-control b-radius-20 shadow-blue"
                      />
                      <div className="text-danger">{errors?.email}</div>
                    </div>
                  </div>

                  <div
                    className="mb-4 fila-contacto align-items-center red-asterisk"
                    id="contacto-desktop"
                  >
                    <div>
                      <label>
                        Celular <span>*</span>
                      </label>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px 1fr",
                        columnGap: "10px",
                      }}
                    >
                      <div>
                        <input
                          type="text="
                          name="celular_prefix"
                          value={values.celular_prefix}
                          onChange={(e) =>
                            handleChangeValue(e, setFieldValue, handleChange, 4)
                          }
                          className="form-control b-radius-20 shadow-blue"
                        />
                        <div className="text-danger">
                          {errors?.celular_prefix}
                        </div>
                      </div>
                      <div>
                        <input
                          type="text"
                          name="celular"
                          value={values.celular}
                          onChange={(e) =>
                            handleChangeValue(e, setFieldValue, handleChange, 8)
                          }
                          className="form-control b-radius-20 shadow-blue"
                        />
                        <div className="text-danger">{errors?.celular}</div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4 form-check">
                    <input
                      name="aceptoPrivacidad"
                      value={values.aceptoPrivacidad}
                      checked={values.aceptoPrivacidad}
                      onChange={handleChange}
                      className="form-check-input"
                      type="checkbox"
                      id="defaultCheck1"
                    />
                    <label className="form-check-label" for="defaultCheck1">
                      Acepto la{" "}
                      <a
                        href="javascript:void(0)"
                        onClick={politicaToggle.onToggle}
                      >
                        política de privacidad
                      </a>{" "}
                      del Hospital Británico *
                    </label>
                    <PoliticaProteccionComponent
                      visible={politicaToggle.toggle}
                      onToggle={politicaToggle.onToggle}
                    />

                    <div className="text-danger">
                      {errors?.validateAceptoPrivacidad}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <div id="botCaptcha">
                        <ReCAPTCHA
                          ref={captcha}
                          sitekey={process.env.REACT_APP_CAPTCHA}
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      type="button"
                      onClick={() => handleSubmit()}
                      className="btn2-color3-r"
                    >
                      Enviar
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
          <div className="col">
            <img src={contacto} className="img-contacto" alt="bg-contacto" />
          </div>
        </div>
      </div>
    </section>
  );
};
export default AfiliarmePage;
